import styles from './PageHead.module.css';

const PageHead = ({ crumb, title, actions }) => (
    <div className={styles.head}>
        <div>
            {crumb && <div className={styles.crumb}>{crumb}</div>}
            <h1 className={styles.title}>{title}</h1>
        </div>
        {actions && <div className={styles.actions}>{actions}</div>}
    </div>
);

export default PageHead;
